import { useContext, useEffect } from "react";
import { AppContext } from "../ContextApi";
import { useNavigate } from "react-router-dom";
import { toast , ToastContainer } from "react-toastify";

const DashboardPolicyTypeTab = ({
    policyVisiblity ,
  policytypename,
  policy_id,
  mykey,
  policy_type_id,
  Tabicon,
  intimateVisibility,
  isTabDisabled,
  scrollToSectionRef
}) => {

  const navigate = useNavigate();

  const {
    activeElementId,
    setActiveElementId,
    setpolicytypeidcontext,
    setGlobalintimateVisiblity,
    setFeaturesType, setScrollBtnActive
  } = useContext(AppContext);

  const handleTabClick = (
    policy_id,
    policy_type_id,
    intimateVisibility,
    policytypename , 
    policyVisiblity
  ) => {
    if(policyVisiblity === 0){
        toast.error("page is unavailable");
        return
    }else{
        setActiveElementId(policy_id);
        navigate("/policy-details")
    }
  };

  function cleanup_active() {
    const tabbox = document.querySelectorAll(".tab-box");
    tabbox.forEach((tab, index) => {
      tab.classList.remove("active-tab-box");
    });
  }



  return (
    <>
      <div className="policy-tab-box-cover dashboard-policy-tab-cover">
        <div
          key={mykey}
          className={
            activeElementId === policy_id
              ? " tab-box dashboard-tab-box"
              : !isTabDisabled
                ? "tab-box disabled-tab dashboard-tab-box"
                : "tab-box dashboard-tab-box"
          }
          onClick={!isTabDisabled ? null : () => handleTabClick(policy_id, policy_type_id, intimateVisibility, policytypename , policyVisiblity)}
        >
          <div className="policytype-img-box">
            <img src={Tabicon}></img>
          </div>
          <h5 className="m-0">{policytypename}</h5>
        </div>
      </div>
      <ToastContainer/>
    </>
  );
};

export default DashboardPolicyTypeTab;
